module.exports = __webpack_public_path__ + "static/media/mllogo.b0edcc05.png";